import Home from '@/components/_pages/Home.vue';
import Impress from '@/components/_pages/Impress.vue';
import AboutUs from '@/components/_pages/About.vue';
import CareerDay from '@/components/_pages/CareerDay.vue';
import HowItWorks from '@/components/_pages/HowItWorks.vue';
import JobAdvertisement from '@/components/_pages/JobAdvertisement.vue';
import JobFind from '@/components/_pages/JobFind.vue';
import Agb from '@/components/_pages/Agb.vue';
import Employee from '@/components/_pages/employee/Employee.vue';
import SecoPilotEmployee from '@/components/_pages/employee/SecoPilot.vue';
import FurtherEducation from '@/components/_pages/employee/FurtherEducation.vue';
import Employer from '@/components/_pages/employer/Employer.vue';
import RulesOfTheGame from '@/components/_pages/employer/RulesOfTheGame.vue';
import SecoPilotEmployer from '@/components/_pages/employer/SecoPilot.vue';
import Jobs from '@/components/_templates/job/Jobs.vue';
import jobList from '@/components/_templates/job/List.vue';
import jobDetail from '@/components/_templates/job/Detail.vue';
import i18n from '../../i18n';

const pageRoutes = [
  {
    path: '/',
    redirect: `/${i18n.locale}`,
  },
  {
    path: '/:lang',
    component: {
      template: '<router-view />',
    },
    children: [
      {
        path: '',
        name: 'home',
        component: Home,
        meta: {
          titleKey: 'pagedefinitions.home.title',
          title: i18n.t('pagedefinitions.home.title'),
          metaTags: [
            {
              name: 'description',
              content: i18n.t('pagedefinitions.home.metaTags.description'),
            },
            {
              property: 'og:description',
              content: i18n.t('pagedefinitions.home.metaTags.description'),
            },
            {
              name: 'keywords',
              content: i18n.t('pagedefinitions.home.metaTags.keywords'),
            },
          ],
        },
      },
      {
        path: 'how-it-works',
        // alias: `${i18n.t('pagedefinitions.howItWorks.path')}`,
        name: 'page.how-it-works',
        component: HowItWorks,
        redirect: { name: 'page.job-advertisement' },
        children: [
          {
            path: 'job-advertisement',
            // alias: i18n.t('pagedefinitions.jobAdvertisement.path'),
            name: 'page.job-advertisement',
            component: JobAdvertisement,
            meta: {
              titleKey: 'pagedefinitions.jobAdvertisement.title',
              title: i18n.t('pagedefinitions.jobAdvertisement.title'),
              metaTags: [
                {
                  name: 'description',
                  content: i18n.t('pagedefinitions.jobAdvertisement.metaTags.description'),
                },
                {
                  property: 'og:description',
                  content: i18n.t('pagedefinitions.jobAdvertisement.metaTags.description'),
                },
                {
                  name: 'keywords',
                  content: i18n.t('pagedefinitions.jobAdvertisement.metaTags.keywords'),
                },
              ],
            },
          },
          {
            path: 'find-a-job',
            // alias: i18n.t('pagedefinitions.findAJob.path'),
            name: 'page.find-a-job',
            component: JobFind,
            meta: {
              titleKey: 'pagedefinitions.findAJob.title',
              title: i18n.t('pagedefinitions.findAJob.title'),
              metaTags: [
                {
                  name: 'description',
                  content: i18n.t('pagedefinitions.findAJob.metaTags.description'),
                },
                {
                  property: 'og:description',
                  content: i18n.t('pagedefinitions.findAJob.metaTags.description'),
                },
                {
                  name: 'keywords',
                  content: i18n.t('pagedefinitions.findAJob.metaTags.keywords'),
                },
              ],
            },
          },
        ],
      },
      {
        path: 'legal-notice',
        // alias: `${i18n.t('pagedefinitions.impress.path')}`,
        name: 'page.impress',
        component: Impress,
        meta: {
          titleKey: 'pagedefinitions.impress.title',
          title: i18n.t('pagedefinitions.impress.title'),
          metaTags: [
            {
              name: 'description',
              content: i18n.t('pagedefinitions.impress.metaTags.description'),
            },
            {
              property: 'og:description',
              content: i18n.t('pagedefinitions.impress.metaTags.description'),
            },
            {
              name: 'keywords',
              content: i18n.t('pagedefinitions.impress.metaTags.keywords'),
            },
          ],
        },
      },
      {
        path: 'about',
        // alias: `${i18n.t('pagedefinitions.about.path')}`,
        name: 'page.about',
        component: AboutUs,
        meta: {
          titleKey: 'pagedefinitions.about.title',
          title: i18n.t('pagedefinitions.about.title'),
          metaTags: [
            {
              name: 'description',
              content: i18n.t('pagedefinitions.about.metaTags.description'),
            },
            {
              property: 'og:description',
              content: i18n.t('pagedefinitions.about.metaTags.description'),
            },
            {
              name: 'keywords',
              content: i18n.t('pagedefinitions.about.metaTags.keywords'),
            },
          ],
        },
      },
      {
        path: 'careerday',
        name: 'page.careerday',
        component: CareerDay,
        meta: {
          titleKey: 'pagedefinitions.careerday.title',
          title: i18n.t('pagedefinitions.careerday.title'),
          metaTags: [
            {
              name: 'description',
              content: i18n.t('pagedefinitions.careerday.metaTags.description'),
            },
            {
              property: 'og:description',
              content: i18n.t('pagedefinitions.careerday.metaTags.description'),
            },
            {
              name: 'keywords',
              content: i18n.t('pagedefinitions.careerday.metaTags.keywords'),
            },
          ],
        },
      },
      {
        path: 'terms-and-conditions',
        // alias: `${i18n.t('pagedefinitions.agb.path')}`,
        name: 'page.agb',
        component: Agb,
        meta: {
          titleKey: 'pagedefinitions.agb.title',
          title: i18n.t('pagedefinitions.agb.title'),
          metaTags: [
            {
              name: 'description',
              content: i18n.t('pagedefinitions.agb.metaTags.description'),
            },
            {
              property: 'og:description',
              content: i18n.t('pagedefinitions.agb.metaTags.description'),
            },
            {
              name: 'keywords',
              content: i18n.t('pagedefinitions.agb.metaTags.keywords'),
            },
          ],
        },
      },
      {
        path: 'employee',
        // alias: `${i18n.t('pagedefinitions.employee.path')}`,
        name: 'page.employee',
        component: Employee,
        children: [
          {
            path: 'further-education',
            // alias: `${i18n.t('pagedefinitions.furtherEducation.path')}`,
            name: 'page.employee.further-education',
            component: FurtherEducation,
            meta: {
              title: i18n.t('pagedefinitions.furtherEducation.title'),
              metaTags: [
                {
                  name: 'description',
                  content: i18n.t('pagedefinitions.furtherEducation.metaTags.description'),
                },
                {
                  property: 'og:description',
                  content: i18n.t('pagedefinitions.furtherEducation.metaTags.description'),
                },
                {
                  name: 'keywords',
                  content: i18n.t('pagedefinitions.furtherEducation.metaTags.keywords'),
                },
              ],
            },
          },
          {
            path: 'seco-pilot',
            // alias: `${i18n.t('pagedefinitions.secoPilotEmployee.path')}`,
            name: 'page.employee.seco-pilot',
            component: SecoPilotEmployee,
            meta: {
              title: i18n.t('pagedefinitions.secoPilotEmployee.title'),
              metaTags: [
                {
                  name: 'description',
                  content: i18n.t('pagedefinitions.secoPilotEmployee.metaTags.description'),
                },
                {
                  property: 'og:description',
                  content: i18n.t('pagedefinitions.secoPilotEmployee.metaTags.description'),
                },
                {
                  name: 'keywords',
                  content: i18n.t('pagedefinitions.secoPilotEmployee.metaTags.keywords'),
                },
              ],
            },
          },
        ],
      },
      {
        path: 'employer',
        // alias: `${i18n.t('pagedefinitions.employer.path')}`,
        name: 'page.employer',
        component: Employer,
        children: [
          {
            path: 'rules-of-the-game',
            // alias: `${i18n.t('pagedefinitions.rulesOfTheGame.path')}`,
            name: 'page.employee.rules-of-the-game',
            component: RulesOfTheGame,
            meta: {
              titleKey: 'pagedefinitions.rulesOfTheGame.title',
              title: i18n.t('pagedefinitions.rulesOfTheGame.title'),
              metaTags: [
                {
                  name: 'description',
                  content: i18n.t('pagedefinitions.rulesOfTheGame.metaTags.description'),
                },
                {
                  property: 'og:description',
                  content: i18n.t('pagedefinitions.rulesOfTheGame.metaTags.description'),
                },
                {
                  name: 'keywords',
                  content: i18n.t('pagedefinitions.rulesOfTheGame.metaTags.keywords'),
                },
              ],
            },
          },
          {
            path: 'seco-pilot',
            // alias: `${i18n.t('pagedefinitions.secoPilotEmployer.path')}`,
            name: 'page.employer.seco-pilot',
            component: SecoPilotEmployer,
            meta: {
              titleKey: 'pagedefinitions.secoPilotEmployer.title',
              title: i18n.t('pagedefinitions.secoPilotEmployer.title'),
              metaTags: [
                {
                  name: 'description',
                  content: i18n.t('pagedefinitions.secoPilotEmployer.metaTags.description'),
                },
                {
                  property: 'og:description',
                  content: i18n.t('pagedefinitions.secoPilotEmployer.metaTags.description'),
                },
                {
                  name: 'keywords',
                  content: i18n.t('pagedefinitions.secoPilotEmployer.metaTags.keywords'),
                },
              ],
            },
          },
        ],
      },
      {
        path: 'jobs',
        component: Jobs,
        children: [
          {
            path: '',
            name: 'job.list',
            component: jobList,
            props: true,
            meta: {
              titleKey: 'pagedefinitions.findAJob.title',
              title: i18n.t('pagedefinitions.findAJob.title'),
              metaTags: [
                {
                  name: 'description',
                  content: i18n.t('pagedefinitions.findAJob.metaTags.description'),
                },
                {
                  property: 'og:description',
                  content: i18n.t('pagedefinitions.findAJob.metaTags.description'),
                },
                {
                  name: 'keywords',
                  content: i18n.t('pagedefinitions.findAJob.metaTags.keywords'),
                },
              ],
            },
          },
          {
            path: ':id',
            name: 'job.detail',
            component: jobDetail,
            meta: {
              titleKey: 'pagedefinitions.findAJob.title',
              title: i18n.t('pagedefinitions.findAJob.title'),
              metaTags: [
                {
                  name: 'description',
                  content: i18n.t('pagedefinitions.findAJob.metaTags.description'),
                },
                {
                  property: 'og:description',
                  content: i18n.t('pagedefinitions.findAJob.metaTags.description'),
                },
                {
                  name: 'keywords',
                  content: i18n.t('pagedefinitions.findAJob.metaTags.keywords'),
                },
              ],
            },
          },
        ],
      },
    ],
  },
];

export default pageRoutes;
